/**
 * Não existe `GET /event_posts/{id}` na api (`config/routes.rb` só roteia
 * `index`/`create` no escopo `user`) — focar um post de deep link só é
 * possível se ele já estiver entre as páginas carregadas. Sem essa rota,
 * buscar indefinidamente arriscaria disparar page após page à toa quando o
 * post expirou ou foi removido; o teto é o limite dessa busca.
 */
export const MAX_FOCUS_EXTRA_PAGES = 5

interface ResolveFocusStepParams {
  posts: { id: number }[]
  focusPostId: number | undefined
  hasMore: boolean
  pagesLoadedForFocus: number
}

interface FocusStep {
  found: boolean
  shouldLoadMore: boolean
}

export function resolveFocusStep({
  posts,
  focusPostId,
  hasMore,
  pagesLoadedForFocus
}: ResolveFocusStepParams): FocusStep {
  if (!focusPostId) return { found: false, shouldLoadMore: false }

  const found = posts.some(post => post.id === focusPostId)
  if (found) return { found: true, shouldLoadMore: false }

  const shouldLoadMore = hasMore && pagesLoadedForFocus < MAX_FOCUS_EXTRA_PAGES
  return { found: false, shouldLoadMore }
}
